import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ProfileComponent } from './profile/profile.component';
import { ProfileServantsComponent } from './profile-servants/profile-servants.component';
import { FamilyComponent } from './family/family.component';
import { ProfileHistoryComponent } from './profile-history/profile-history.component';
import { PipeModule } from '../pipes/pipe.module';
import { ProfileService } from '../services/profile.service';
import { LoginService } from '../services/login.service';
import { ProfileReportsComponent } from './profile-reports/profile-reports.component';

@Component({
  selector: 'app-profile-container',
  templateUrl: './profile-container.component.html',
  styleUrls: ['./profile-container.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, ProfileComponent, ProfileServantsComponent, FamilyComponent, ProfileHistoryComponent, ProfileReportsComponent, PipeModule]
})
export class ProfileContainerComponent implements OnInit {
  pageView = 'profile';
  @Input() profileId: number = 0;
  @Input() familyId: number = 0;
  @Input() isNewAppUser: boolean = false;
  @Input() isCoordinator: boolean = false;
  @Input() profileAssignmentId: number = 0;

  showHistoryTab = true;
  @ViewChild('tabcontainer', { static: true }) tabscontainer!: ElementRef;

  constructor(private profileService: ProfileService, private userService: LoginService) { }

  ngOnInit() {
    if (this.profileId === this.userService.currentUser?.ProfileId) {
      this.showHistoryTab = false;
    }

    this.profileService.familyIdEvent.subscribe(familyId => {
      this.familyId = familyId;
    });

    this.scrollAnimation();
  }

  scrollAnimation() {
    setTimeout(() => {
      if (this.tabscontainer) {
        this.tabscontainer.nativeElement.scrollLeft = 0;
        let container = this.tabscontainer.nativeElement;
        let scrollAmount = 0;

        var slideTimer = setInterval(function () {
          container.scrollLeft += 10;
          scrollAmount += 10;
          if (scrollAmount >= 100) {
            window.clearInterval(slideTimer);
          }
        }, 25);


        setTimeout(() => {
          scrollAmount = 0;
          var slideTimer = setInterval(function () {
            container.scrollLeft -= 10;
            scrollAmount += 10;
            if (scrollAmount >= 100) {
              window.clearInterval(slideTimer);
            }
          }, 25);
        }, 1500);
      }
    }, 1000);
  }


  onPageChange(newPage: string) {
    this.pageView = newPage;
  }

  closeProfile() {
    this.profileService.closeProfileEvent.emit(0);
  }
}
